Vue.component('legacy-card-library', {
  template: templates.legacyCardLibrary,
  data() {
    return {
      model: {
        cards: {
          legacy: []
        },
        page: {
          current: 1,
          max: 18,
          cards: [],
          count: 0,
          total: 0,
          totalPages: 0,
          hasNext: false,
          hasPrev: false,
          isLoading: false
        },
        viewerCard: false
      }
    }
  },
  beforeDestroy() {
    const c = this;

    // Clean up root events
    c.$root.$off('loadLegacyCards');

    // Clean up DOM event listeners
    $('[data-view="viewer-dashboard"]').off('click', '[data-component="playing-card"]');
    $('[data-view="viewer-dashboard"]').off('click', '[data-component="special-card"]');
    $('[data-view="viewer-dashboard"]').off('click', '.view-card');

    // Reset card animations
    $('.playing-card').removeClass('flipped fade_in');
    $('.special-card').removeClass('flipped fade_in');
    $('.view-card').removeClass('is-above is-visible');

    // Reset pagination if it exists
    if ($(".pagination").length) {
      try {
        $(".pagination").off();
      } catch (e) {
        // Ignore errors if pagination cleanup fails
      }
    }

    // Clear view card content
    $('.view-card > div').html('');
  },
  mounted() {
    const c = this;

    // Initialize by loading legacy cards on mount
    c.getLegacyCards();

    $('[data-view="viewer-dashboard"]').on('click', '[data-component="playing-card"]', function(e) {
      if (!e.ctrlKey && utils.onHold == false) {
        c.showCard($(this).find('.playing-card-front').clone());
      }
    });

    $('[data-view="viewer-dashboard"]').on('click', '[data-component="special-card"]', function(e) {
      if (!e.ctrlKey && utils.onHold == false) {
        c.showSpecialCard($(this).find('.playing-card-front').clone());
      }
    });

    $('[data-view="viewer-dashboard"]').on('click', '.view-card', function(e) {
      if ($(e.target).closest('.equipped-indicator').length) return;
      c.hideCard();
    });

    c.$root.$on(`loadLegacyCards`, () => {
      c.getLegacyCards();
    });
  },
  methods: {
    showCard($card) {
      let ability = $card.find('.bottom > div:first-of-type').attr('title').replace('Ability: ', '');
      let description = $card.find('.bottom > div:first-of-type').data('description');
      $('.view-card > div').append($card).append(`<p class="description"><span>${ability}:</span> ${description}</p>`);
      $('.view-card').addClass('is-above').addClass('is-visible');
      $('.view-card .info').removeClass('is-visible');
      $('.view-card .bottom').removeClass('is-hidden');
      $('.hq-nav').removeClass('indexed');
      $('.stats-bar').removeClass('indexed');
    },
    showSpecialCard($card) {
      let description = $card.find('.bottom > div:first-of-type').data('description');
      $('.view-card > div').append($card);
      $('.view-card').addClass('is-above').addClass('is-visible');
      $('.view-card .info').removeClass('is-visible');
      $('.view-card .bottom').removeClass('is-hidden');
      $('.hq-nav').removeClass('indexed');
      $('.stats-bar').removeClass('indexed');
    },
    hideCard() {
      $('.hq-nav').addClass('indexed');
      $('.stats-bar').addClass('indexed');
      $('.view-card').removeClass('is-visible');
      setTimeout(function() {
        $('.view-card').removeClass('is-above');
        $('.view-card > div').html('');
      }, 300);
    },
    getLegacyCards(page = 1) {
      const c = this;
      c.model.page.isLoading = true;

      userService.getLegacyCards(page, c.model.page.max)
        .then(function (response) {

          // Extract pagination metadata
          const pagination = response.data.pagination;
          c.model.page.current = pagination.page;
          c.model.page.total = pagination.total;
          c.model.page.totalPages = pagination.totalPages;
          c.model.page.hasNext = pagination.hasNext;
          c.model.page.hasPrev = pagination.hasPrev;
          c.model.page.count = c.model.page.totalPages;

          // Process card data
          const legacyCards = response.data.cards.map(card => {
            card.image = `${root}/images/cards/${card.id}.png`;
            return playingCards.getCardStats(card);
          });

          c.model.cards.legacy = legacyCards.map(v => ({...v, selected: false}));
          c.model.page.cards = c.model.cards.legacy;
          c.model.page.isLoading = false;

          setTimeout(function() {
            $(".pagination").rPage();
            $('.playing-card:not(.disabled)').addClass('flipped');
            $('.special-card:not(.disabled)').addClass('flipped');
          }, 1000);

        })
        .catch(function (error) {
          c.model.page.isLoading = false;
          console.error('Error loading legacy cards:', error);
        });
    },
    setPage(pageNumber) {
      const c = this;
      if (pageNumber >= 1 && pageNumber <= c.model.page.totalPages) {
        c.getLegacyCards(pageNumber);
      }
    },
    nextPage() {
      const c = this;
      if (c.model.page.hasNext) {
        c.getLegacyCards(c.model.page.current + 1);
      }
    },
    previousPage() {
      const c = this;
      if (c.model.page.hasPrev) {
        c.getLegacyCards(c.model.page.current - 1);
      }
    }
  }
});
